export default __webpack_public_path__ + "99aae91.png";